// Simple notification sound utility
import notificationAudioFile from '../../assets/audo&video/mixkit-software-interface-start-2574.mp3';

// Create a reference to the audio element
let audioElement = null;

// Function to initialize the audio element
export const initNotificationAudio = (id = 'notification-sound') => {
  // Check if the audio element already exists
  if (!document.getElementById(id)) {
    // Create a new audio element
    audioElement = document.createElement('audio');
    audioElement.id = id;
    audioElement.src = notificationAudioFile;
    audioElement.preload = 'auto';
    document.body.appendChild(audioElement);
  } else {
    // Use existing audio element
    audioElement = document.getElementById(id);
  }
  return audioElement;
};

// Export function for playing the notification sound
export const playNotificationSound = (id = 'notification-sound') => {
  if (!audioElement) {
    initNotificationAudio(id);
  }
  if (!audioElement) return;

  try {
    audioElement.currentTime = 0;
    const playPromise = audioElement.play();
    if (playPromise) {
      playPromise.catch(err => console.warn('Audio playback failed:', err));
    }
  } catch (err) {
    console.warn('Audio playback failed:', err);
  }
};
